module.exports = __webpack_public_path__ + "static/media/conveyor-belt-alt.d4c2744f.svg";